import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {MatDialogRef} from "@angular/material/dialog";
import {AttributeSelectorOptions} from "./options/attribute-selector.options";
import {ListResponse} from "../../../../network/service/list.response";
import {SnackBarUtil} from "../../../../util/snack.bar.util";
import {RequestType} from "../../../../enums/request.type";

@Component({
  selector: 'app-attribute-selector',
  standalone: false,
  templateUrl: './attribute-selector.component.html',
  styleUrls: ['./attribute-selector.component.scss']
})
export class AttributeSelectorComponent extends BaseComponent implements OnInit {
  attributeSelectorOptions = new AttributeSelectorOptions();
  attributes?: any = [];
  attributeResults?: any = [];
  attributeTypes: any = [];
  selectedType: any;
  selectAllValue?: any;
  attributeTitle?: any;
  savedAttribute?: any = [];

  constructor(injector: Injector, private matDialogRef: MatDialogRef<AttributeSelectorComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.savedAttribute = ((this.attributeSelectorOptions ?? {}).attributeList ?? []);
  }

  override loadOnline() {
    super.loadOnline();
    this.serviceApi.getAttributeType(this.tableProperties.offset, this.tableProperties.limit, undefined, RequestType.ALL, undefined).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.attributeTypes = res.data;
        this.tableProperties.pageLength = res.count;
        this.serviceApi.getAttribute(this.tableProperties.offset, this.tableProperties.limit, undefined, RequestType.ALL, undefined).subscribe((res: ListResponse<any>) => {
          if (res.success) {
            this.attributes = res.data;
            this.tableProperties.pageLength = res.count;
            this.setListeners();
          } else {
            SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
          }
        });
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  noAction() {
    this.matDialogRef.close();
  }

  override setListeners() {
    for (let i = 0; i < this.attributes.length; i++) {
      for (let j = 0; j < this.savedAttribute.length; j++) {
        this.attributes[i].IsSelected = this.attributes[i].AttributeId === this.savedAttribute[j].AttributeId;
      }
    }
    this.attributeResults = this.attributes;
    for (let i = 0; i < this.attributeTypes.length; i++) {
      if (this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.attributeTypes[i].AttributeTypeId && attribute.IsSelected === true)) {
        this.attributeTypes[i].Status = {
          HasSelectedValue: true
        };
      } else {
        this.attributeTypes[i].Status = {
          HasSelectedValue: false
        };
      }
    }
    this.onSelectAttributeTypeClicked();
  }

  onSelectAttributeTypeClicked(type?: any, title?: string) {
    this.selectedType = type;
    if (type) {
      this.attributeResults = this.attributes.filter((attribute: any) => attribute.AttributeTypeId === type.AttributeTypeId && (title && title !== '' ? attribute.AttributeTitle.includes(title) : {}));
      for (let i = 0; i < this.savedAttribute.length; i++) {
        for (let j = 0; j < this.attributeResults.length; j++) {
          if (this.attributeResults[j].AttributeId === this.savedAttribute[i].AttributeId) {
            this.attributeResults[j].IsSelected = true;
          }
        }
      }
      this.selectAllValue = this.attributeResults.every((attribute: any) => attribute.IsSelected === true);
      this.attributeTypes = this.attributeTypes.map((at: any) => {
        if (at.AttributeTypeId === this.selectedType.AttributeTypeId) {
          at.Status.HasSelectedValue = !!this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.selectedType.AttributeTypeId && attribute.IsSelected === true);
        }
        return at;
      });
    } else {
      this.attributeResults = this.attributes.filter((attribute: any) => (title && title !== '' ? attribute.AttributeTitle.includes(title) : {}));
      for (let i = 0; i < this.savedAttribute.length; i++) {
        for (let j = 0; j < this.attributeResults.length; j++) {
          if (this.attributeResults[j].AttributeId === this.savedAttribute[i].AttributeId) {
            this.attributeResults[j].IsSelected = true;
          }
        }
      }
      this.selectAllValue = this.attributeResults.every((attribute: any) => attribute.IsSelected === true);
      for (let i = 0; i < this.attributeTypes.length; i++) {
        this.attributeTypes[i].Status.HasSelectedValue = !!this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.attributeTypes[i].AttributeTypeId && attribute.IsSelected === true);
      }
    }
  }

  onAttributeClicked(checked: boolean) {
    if (this.selectedType) {
      for (let i = 0; i < this.attributeResults.length; i++) {
        if (this.attributeResults[i].AttributeTypeId === this.selectedType.AttributeTypeId) {
          this.attributeResults[i].IsSelected = checked;
        }
      }
      this.attributeTypes = this.attributeTypes.map((at: any) => {
        if (at.AttributeTypeId === this.selectedType.AttributeTypeId) {
          at.Status.HasSelectedValue = !!this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.selectedType.AttributeTypeId && attribute.IsSelected === true);
        }
        return at;
      });
    } else {
      for (let i = 0; i < this.attributeResults.length; i++) {
        this.attributeResults[i].IsSelected = checked;
      }
      for (let i = 0; i < this.attributeTypes.length; i++) {
        this.attributeTypes[i].Status.HasSelectedValue = !!this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.attributeTypes[i].AttributeTypeId && attribute.IsSelected === true);
      }
    }
    this.selectAllValue = this.attributeResults.every((attribute: any) => attribute.IsSelected === true);
  }

  hasSomeSelectedAttributes() {
    return !!this.attributeTypes.some((at: any) => at?.Status?.HasSelectedValue === true);
  }

  onChangeChecked(attribute?: any, checked?: boolean) {
    for (let i = 0; i < this.attributeResults.length; i++) {
      if (this.attributeResults[i].AttributeId === attribute.AttributeId) {
        this.attributeResults[i].IsSelected = checked;
      }
    }
    for (let i = 0; i < this.attributeTypes.length; i++) {
      if (this.attributeTypes[i].AttributeTypeId === attribute.AttributeTypeId) {
        this.attributeTypes[i].Status.HasSelectedValue = !!this.attributeResults.some((attribute: any) => attribute.AttributeTypeId === this.attributeTypes[i].AttributeTypeId && attribute.IsSelected === true);
      }
    }
    this.selectAllValue = this.attributeResults.every((at: any) => at.AttributeTypeId === attribute.AttributeTypeId && at.IsSelected === true);
  }

  onSubmitClicked() {
    let attributes = this.attributes.filter((attribute: any) => attribute.IsSelected === true);
    this.attributeSelectorOptions.onAttributeSelected(attributes);
    this.noAction();
  }
}
